




























import { Component, Vue, Prop } from "vue-property-decorator";
import { GetCenterInfo, GetZhuanbingJiheLiebiao } from "@/request/edr";
import Copy from "@/components/copy.vue";
import SimplePagination from "@/components/simple_pagination.vue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import EdrLeftNav from "../../components/left-nav.vue";
@Component({
  components: {
    MainHeader,
    EdrLeftNav,
    Copy,
    SimplePagination
  }
})
export default class EdrMobanList extends Vue {
  private center: any = {};
  //   private currentPage: any = 1;
  //   private pageCount: any = 10;
  //   private total: any = 0;
  //   private totalPage: any = 0;
  private list: any[] = [];
  /**
   * @description 获得名中医中心的信息
   */
  private fetchCenterInfo() {
    return new Promise((resolve, reject) => {
      const params: any = {
        params: {
          project_id: this.$route.query.project_id
        }
      };
      GetCenterInfo(this, params)
        .then((data: any) => {
          this.center = data;
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 获得crf量表
   */
  private fetchList() {
    const params: any = {
      params: {
        project_id: this.center.project_id,
        group_id: this.center.group_id
      }
    };
    GetZhuanbingJiheLiebiao(this, params).then((data: any) => {
      this.list = data;
      //   this.total = data.total_count;
      //   this.totalPage = data.total_page;
    });
  }
  /**
   * @description 跳转crf列表
   */
  private jumpCrfList(l) {
    console.log(l);
  }
  //   /**
  //    * @description 搜索
  //    */
  //   private search() {
  //     this.currentPage = 1;
  //     this.fetchList();
  //   }
  //   /**
  //    * @description 前一页
  //    */
  //   private prev() {
  //     if (this.currentPage === 1) {
  //       return;
  //     } else {
  //       this.currentPage--;
  //       this.fetchList();
  //     }
  //   }
  //   /**
  //    * @description 后一页
  //    */
  //   private next() {
  //     if (this.currentPage >= this.totalPage) {
  //       return;
  //     } else {
  //       this.currentPage++;
  //       this.fetchList();
  //     }
  //   }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchCenterInfo().then(() => {
      this.fetchList();
    });
  }
}
